import { VehicleInfo } from "../types";

export const mockVehicleInfo: VehicleInfo = {
  region: "South East Queensland",
  station: "Sunnybank Hills",
  code: "1230",
  callSign: "555",
  portableDevices: "Radio 123",
};
